
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.304 8.112c1.574-2.844 3.17-5.263 3.187-5.287a.812.812 0 011.353 0c.016.024 1.613 2.443 3.187 5.287 2.16 3.904 3.254 6.74 3.254 8.43a6.851 6.851 0 01-2.103 5.07 7.583 7.583 0 01-10.03 0 6.851 6.851 0 01-2.102-5.07c0-1.69 1.095-4.526 3.254-8.43z","stroke":"currentColor","stroke-width":"1.118"}}),_c('path',{attrs:{"d":"M9.314 16.985a4.748 4.748 0 003.927 4.22","stroke":"currentColor","stroke-width":"1.118","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M15.397 6.15a6.15 6.15 0 1112.298-.001 6.15 6.15 0 01-12.298 0z","fill":"#5EC7F2"}}),_c('path',{attrs:{"d":"M20.672 7.75h-.75v.77H18.85v-.77h-.75V6.728h.75v-.774h1.072v.774h.75V7.75zm2.323-3.608L21.66 9.943H20.59l1.338-5.8h1.067zM25.94 6.77v.92h-2.883v-.92h2.883z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"26.037","cy":"15.804","r":"1.118","stroke":"currentColor","stroke-width":"1.118"}}),_c('circle',{attrs:{"cx":"14.857","cy":"28.102","r":"1.118","stroke":"currentColor","stroke-width":"1.118"}}),_c('circle',{attrs:{"cx":"6.193","cy":"3.786","r":".28","stroke":"currentColor","stroke-width":"1.118"}}),_c('circle',{attrs:{"cx":"23.522","cy":"24.469","r":".28","stroke":"currentColor","stroke-width":"1.118"}}),_c('circle',{attrs:{"cx":"3.957","cy":"23.351","r":".28","stroke":"currentColor","stroke-width":"1.118"}}),_c('circle',{attrs:{"cx":"3.677","cy":"12.45","r":"1.118","stroke":"currentColor","stroke-width":"1.118"}})])
          )
        }
      }
    